<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> DLI profiel</strong>
                        <small>
                            <span v-show="profielbestaat">wijzigen</span>
                            <span v-show="!profielbestaat">creëren</span>
                        </small>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <tbody>
                                <tr>
                                    <th>Afdeling: </th><td>{{model.afdeling.naam}}</td>

                                </tr>
                                <tr>
                                    <th>Gewas: </th><td>{{model.teelt.naam}} - {{model.ras}}</td>
                                    <th>Aanplantdatum - einddatum: </th>
                                    <td>{{datumDDMMYYYY(model.aanplantdatum)}} - {{datumDDMMYYYY(model.einddatum)}}</td>
                                </tr>
                                <tr>
                                    <th>Gewenste DLI: </th><td>{{model.ingesteldeDli}}</td>
                                    <th>Belichtingsseizoen start - einde: </th>
                                    <td>{{datumDDMMYYYY(model.startdatumBelichting)}} - {{datumDDMMYYYY(model.einddatumBelichting)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-show="!profielbestaat" class="row">
                        <div class="col-12">
                            <p class="red">Er bestaat nog geen DLI profiel voor deze teelt.</p>
                        </div>
                    </div>

                    <div v-show="!profielbestaat" class="row">
                        <div class="col-12">
                            <b-button type="button" @click="createvastprofiel" variant="primary">Vast DLI profiel creëren</b-button>
                            &nbsp;
                            <b-button type="button" @click="createadaptiefprofiel" variant="primary">Adaptief DLI profiel creëren</b-button>
                            <br />&nbsp;<br />
                        </div>
                    </div>

                    <div v-show="profielbestaat" class="row">
                        <div class="col-sm-6">
                            <br />
                        </div>
                    </div>

                    <div v-show="profielbestaat" class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <b-button-group id="periode" name="periode">
                                    <b-button @click="changeView('data')" variant="outline-secondary" :pressed="currentview == 'data'">Data</b-button>
                                    <b-button @click="changeView('grafiek')" variant="outline-secondary" :pressed="currentview == 'grafiek'">Grafiek</b-button>
                                </b-button-group>
                            </div>
                            &nbsp<br />
                        </div><!--/.col-->

                        <div v-show="currentview == 'data'" class="col-sm-8">
                            <b-button type="button" @click="createvastprofiel" variant="primary">Nieuw vast DLI profiel creëren</b-button>
                            <b-button type="button" @click="createadaptiefprofiel" variant="primary">Nieuw adaptief DLI profiel creëren</b-button>
                            <b-button type="button" @click="openFormImport()" variant="secondary" style="background-color : #ffffff;">DLI profiel importeren</b-button>
                        </div>

                        <div v-show="currentview == 'grafiek'" class="col-sm-6">
                            <b-input-group>
                                <b-input-group left="Van">
                                    <datepicker @input="fillGraphData()" :required="true" v-model="begindatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :language="nl" :monday-first="true" name="begindatum" id="begindatum" ref="begindatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;
                                <b-input-group left="Tot">
                                    <datepicker @input="fillGraphData()" :required="true" v-model="einddatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :language="nl" :monday-first="true" name="einddatum" id="einddatum" ref="einddatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </b-input-group>
                        </div><!--/.col-->
                    </div>

                    <div v-show="profielbestaat && currentview == 'data'" class="row animated fadeIn">
                        <div class="col-12">
                            <table class="table table-striped table-sm text-center table-fixed">
                                <thead>
                                <tr>
                                    <th>Datum</th>
                                    <th></th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <!-- alleen voor tomaten -->
                                    <th v-if="[1, 7, 8].includes(model.teelt.id)"></th>
                                    <th v-if="[1, 7, 8].includes(model.teelt.id)">Plantbehang</th>
                                </tr>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <td>29/02/2020</td>
                                    <td>
                                        <a href="javascript:void(0)">
                                            <i class="fa fa-navicon"></i>
                                        </a>
                                    </td>
                                    <td style="text-align: center;">
                                        <div class="centered">
                                            <input type="number" step=".1" min="0" max="99.9" class="form-control smallwidth" />
                                        </div>
                                    </td>
                                    <!-- alleen voor tomaten -->
                                    <td v-if="[1, 7, 8].includes(model.teelt.id)">
                                        <a href="javascript:void(0)">
                                            <i class="fa fa-navicon"></i>
                                        </a>
                                    </td>
                                    <td v-if="[1, 7, 8].includes(model.teelt.id)" style="text-align: center;">
                                        <div class="centered">
                                            <input type="number" step="1" min="0" max="99" class="form-control smallwidth" />
                                        </div>
                                    </td>
                                </tr>
                                <!-- tot hier -->

                                </thead>

                                <tbody>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <th>Datum</th>
                                    <th></th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <th v-if="[1, 7, 8].includes(model.teelt.id)"></th>
                                    <th v-if="[1, 7, 8].includes(model.teelt.id)">Planbehang</th>
                                </tr>
                                <!-- tot hier -->

                                <tr v-for="(historiekteelt, indexi) in model.historiekteelt_n">
                                    <td>{{datumDDMMYYYY(historiekteelt.datum)}}</td>
                                    <td>
                                        <a href="javascript:void(0)" @click="klikt(indexi)">
                                            <i v-bind:class="selectValue(historiekteelt)"></i>
                                        </a>
                                    </td>
                                    <td style="text-align: center;">
                                        <div class="centered">
                                            <input required @keyup.delete="wis(historiekteelt)" type="number" step=".1" min="0" max="99.9" class="form-control smallwidth" v-model="historiekteelt.gewensteDli" id="gewensteDli" name="'gewensteDli' + indexi)" />
                                        </div>
                                    </td>
                                    <td v-if="[1, 7, 8].includes(model.teelt.id)">
                                        <a href="javascript:void(0)" @click="klikt2(indexi)">
                                            <i v-bind:class="selectValue2(historiekteelt)"></i>
                                        </a>
                                    </td>
                                    <td v-if="[1, 7, 8].includes(model.teelt.id)" style="text-align: center;">
                                        <div class="centered">
                                            <input required @keyup.delete="wis2(historiekteelt)" type="number" pattern="\d*" step="1" min="0" max="99" class="form-control smallwidth" v-model="historiekteelt.plantdichtheid" id="plantdichtheid" name="'plantdichtheid' + indexi)" />
                                        </div>
                                    </td>

                                </tr>

                                </tbody>
                            </table>
                        </div><!--/.col-->
                    </div><!--/.row-->

                    <div v-show="profielbestaat && currentview == 'grafiek'" class="row animated fadeIn">
                        <div class="col-12">
                            <h5 class="card-title mb-0">DLI profiel</h5>
                            <br />
                            <div class="small text-muted">mol/m<sup>2</sup></div>

                            <chart :chart-data="datacollection" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny" :maxy="maxy" :changeyaxis="changeyaxis"></chart>
                        </div>
                    </div>

                    <form @submit.prevent="saveItem">

                    <div slot="footer">
                        <b-button v-show="profielbestaat" type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>

                    </form>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint max-len: ["error", { "code": 300 }] */
    import Datepicker from 'vuejs-datepicker';
    import { nl } from 'vuejs-datepicker/dist/locale';

    import datefunctions from '../../helpers/datefunctions';
    import Chart from './ChartLineVerticalLine';

    export default {
        name: 'Form',
        props: ['model', 'isEditing'],
        data () {
            return {
                nl,
                // eerste aangeklikte rij (voor gewenste DLI en voor plantdichtheid)
                firstrow: -1,
                firstrow2: -1,
                currentview: 'data',
                datacollection: null,
                miny: 0,
                maxy: 25,
                changeyaxis: false, // telkens deze wijzigt, hertekent de grafiek zich
                begindatum: '',
                einddatum: '',
                disabled: {
                    to: new Date(),
                    from: new Date(),
                },
            };
        },
        methods: {
            changeView (view) {
                this.currentview = view;
                if (view === 'grafiek') {
                    if (this.begindatum === '') {
                        this.begindatum = new Date(this.model.historiekteelt_n[0].datum);
                        this.einddatum = new Date(this.model.historiekteelt_n[this.model.historiekteelt_n.length - 1].datum);
                        this.disabled.to = this.begindatum;
                        this.disabled.from = this.einddatum;
                    }
                    this.fillGraphData();
                }
            },
            getMaxValueDatasets (datasets) {
                let maxwaarde = 0;
                datasets.forEach((dataset) => {
                    maxwaarde = Math.max(maxwaarde, Math.max(...dataset.data));
                });
                return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
            },
            fillGraphData () {
                let lines = [];
                let values = [];
                this.getPlantdichtheid(lines, values);
                this.datacollection = {
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphBarsAndLines(),
                    verticallines: lines, // [0, 10, 17, 25, 30, 46],
                    values: values, // [13, 5, 8, 21, 10, 16],
                };
                this.miny = 0;
                this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
                this.changeyaxis = !this.changeyaxis;
            },
            getPlantdichtheid(lines, values)  {
                let vorigedichtheid = 0;
                let indexcount = 0;
                this.model.historiekteelt_n.forEach((historiekteelt) => {
                    if ((historiekteelt.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (historiekteelt.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        if (vorigedichtheid != historiekteelt.plantdichtheid) {
                            lines.push(indexcount);
                            values.push((historiekteelt.plantdichtheid == null  ? "" : historiekteelt.plantdichtheid));
                            vorigedichtheid = historiekteelt.plantdichtheid;
                        }
                        indexcount = indexcount + 1;
                    }
                });
            },
            getGraphLabels () {
                const labels = [];
                this.model.historiekteelt_n.forEach((historiekteelt) => {
                    if ((historiekteelt.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (historiekteelt.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        labels.push(this.datumDDMMYYYY(historiekteelt.datum));
                    }
                });
                return labels;
            },
            getGraphBarsAndLines () {
                const datasets = [];
                this.getGraphDliGewenst(datasets);
                return datasets;
            },
            getGraphDliGewenst (datasets) {
                const data = [];
                this.model.historiekteelt_n.forEach((historiekteelt) => {
                    if ((historiekteelt.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (historiekteelt.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(historiekteelt.gewensteDli);
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(23,23,23, 0)',
                    borderColor: 'rgba(23,23,23, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    label: ' DLI gewenst',
                    data,
                };
                datasets.push(dataset);
            },
            wis (historiekteelt) {
                historiekteelt.gewensteDli = '0';
            },
            wis2 (historiekteelt) {
                historiekteelt.plantdichtheid = '0';
            },
            // voor kopiëren van gewenste DLI
            klikt (index) {
                if (this.model.historiekteelt_n[index].selected === 0) {
                    if (this.firstrow === -1) {
                        this.model.historiekteelt_n[index].selected = 1;
                        this.firstrow = index;
                    } else if (this.firstrow < index) {
                        for (let i = this.firstrow + 1; i <= index; i += 1) {
                            this.model.historiekteelt_n[i].gewensteDli =
                                this.model.historiekteelt_n[this.firstrow].gewensteDli;
                        }
                        this.model.historiekteelt_n[this.firstrow].selected = 0;
                        this.firstrow = -1;
                    }
                } else {
                    this.model.historiekteelt_n[index].selected = 0;
                    this.firstrow = -1;
                }
            },
            selectValue (historiekteelt) {
                if (historiekteelt.selected === 0) {
                    return 'fa fa-navicon';
                }
                if (historiekteelt.selected === 1) {
                    return 'fa fa-sort-amount-asc';
                }
                return '';
            },
            // voor kopiëren van plantdichtheid (eigenlijk beter met dezelfde functies van boven)
            klikt2 (index) {
                if (this.model.historiekteelt_n[index].selected2 === 0) {
                    if (this.firstrow2 === -1) {
                        this.model.historiekteelt_n[index].selected2 = 1;
                        this.firstrow2 = index;
                    } else if (this.firstrow2 < index) {
                        for (let i = this.firstrow2 + 1; i <= index; i += 1) {
                            this.model.historiekteelt_n[i].plantdichtheid =
                                this.model.historiekteelt_n[this.firstrow2].plantdichtheid;
                        }
                        this.model.historiekteelt_n[this.firstrow2].selected2 = 0;
                        this.firstrow2 = -1;
                    }
                } else {
                    this.model.historiekteelt_n[index].selected2 = 0;
                    this.firstrow2 = -1;
                }
            },
            selectValue2 (historiekteelt) {
                if (historiekteelt.selected2 === 0) {
                    return 'fa fa-navicon';
                }
                if (historiekteelt.selected2 === 1) {
                    return 'fa fa-sort-amount-asc';
                }
                return '';
            },
            createvastprofiel () {
                this.$emit('create-vast-profiel', this.model);
            },
            createadaptiefprofiel () {
                this.$emit('create-adaptief-profiel', this.model);
            },
            openFormImport () {
                this.$emit('open-form-import', this.model);
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
        },
        computed: {
            profielbestaat () {
                return (this.model.historiekteelt_n.length !== 0);
            },
        },
        components: {
            datepicker: Datepicker,
            chart: Chart,
        },
    };
</script>

<style>

    .red {
        color: red;
    }

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .smallwidth {
        padding: 0.1em;
        width: 4em;
    }

    .centered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .table-nonfluid {
        width: auto !important;
    }

    .table-fixed tbody {
        height: calc( 100vh - 180px );
        overflow-y: auto;
    }

    .table-fixed thead, .table-fixed tbody {
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/FormDliprofiel.vue